module.exports = __webpack_public_path__ + "img/70.386753a7.jpg";